import React, { useContext, useEffect } from "react";
import "../../assets/styles/smu-breadcrumbs.scss";
import { StoreContext } from "../../store/StoreContext";
import _ from "lodash";
import { routes } from "../../router";
import { useLocation } from "react-router-dom";

const SmuBreadcrumbs = () => {
  const location = useLocation();
  const { currentRoute, setCurrentRoute } = useContext(StoreContext);

  const nBreadcrumb = currentRoute?.breadcrumbs?.length || 0;

  useEffect(() => {
    let route = routes.find((r) => r.path === location.pathname);
    const mainId = location.search.replace("?id=", "");
    const ids = mainId.split(".");

    let id = ids[0];
    ids.forEach((_id, i) => {
      if (i > 0) id += "." + _id;
      route = _.find(route?.children, (r) => r.id === id);
    });

    setCurrentRoute(route);
  }, [location]);

  return (
    <div
      className={`smu-breadcrumbs px-4 ${nBreadcrumb === 0 ? "d-none" : ""}`}
    >
      {_.map(currentRoute?.breadcrumbs, (item, i) => (
        <div key={i} className="breadcrumb">
          {i === 0 && currentRoute?.Icon && (
            <currentRoute.Icon color={"#748a9d"} />
          )}
          <span className={`title ${i === 0 ? "ms-2" : ""}`}>{item.title}</span>
          {i + 1 < nBreadcrumb && <span className="space">/</span>}
        </div>
      ))}
    </div>
  );
};

export default SmuBreadcrumbs;
